import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white shadow-sm' : 'bg-transparent'
      }`}
    >
      <div className="px-20 py-6">
        <div className="flex items-center justify-between">
          {/* Logo */}
          <Link to="/" className="flex items-center">
            <img 
              src="https://static.readdy.ai/image/d72009ffd1e4e89ac0953842d25105ae/c47d24cecc70264c14f156beead025f4.png" 
              alt="Edbilities" 
              className="h-10 w-auto"
            />
          </Link>

          {/* Center Navigation */}
          <div className="hidden md:flex items-center space-x-12">
            <button
              onClick={() => scrollToSection('how-it-works')}
              className="text-warm-gray hover:text-charcoal transition-colors duration-200 text-base font-sans whitespace-nowrap cursor-pointer"
            >
              How It Works
            </button>
            <button
              onClick={() => scrollToSection('professional-english')}
              className="text-warm-gray hover:text-charcoal transition-colors duration-200 text-base font-sans whitespace-nowrap cursor-pointer"
            >
              Approach
            </button>
            <button
              onClick={() => scrollToSection('testimonials')}
              className="text-warm-gray hover:text-charcoal transition-colors duration-200 text-base font-sans whitespace-nowrap cursor-pointer"
            >
              Testimonials
            </button>
          </div>

          {/* Right Side CTAs */}
          <div className="flex items-center space-x-6">
            <button
              onClick={() => scrollToSection('how-it-works')}
              className="hidden md:block text-warm-gray hover:text-charcoal transition-colors duration-200 text-base font-sans whitespace-nowrap cursor-pointer"
            >
              See How It Works
            </button>
            <button
              onClick={() => scrollToSection('cta')}
              className="bg-charcoal text-white px-8 py-3.5 rounded-lg hover:bg-charcoal/90 transition-all duration-200 text-base font-medium font-sans whitespace-nowrap cursor-pointer"
            >
              Get Started
            </button>
          </div>
        </div>
      </div>
    </nav>
  );
}
